import React from 'react';
import { Icon } from '../Icon';
import { IIcon } from '@interfaces';

export function AttentionIcon(props: IIcon) {
    return (
        <Icon
            width={props.width}
            height={props.height}
            viewBox={props.viewBox}
            style={props.style}
            className={props.className}
        >
            <g>
                <path d="M255.9,328.8c7.3,0,17.6-4,17.6-13.4c0-36.2,4.3-88.2,4.3-124.3c0-11.9-10-18.5-21.9-18.5c-12.5,0-22.2,6.7-22.2,18.5c0,36.2,4.3,88.2,4.3,124.3C238,324.9,246.2,328.8,255.9,328.8z" />
                <path d="M254.9,349.8c-13.4,0-23.4,10.6-23.4,23.4c0,12.5,10,23.4,23.4,23.4c12.5,0,23.1-10.9,23.1-23.4C278,360.4,267.4,349.8,254.9,349.8z" />
                <path d="M494.1,400.1l-201-331.2l0,0c-7.8-12.9-21.4-20.5-36.5-20.6c0,0,0,0-0.1,0c-15,0-28.6,7.6-36.5,20.5L17.5,400c-8.2,13.4-8.5,29.5-0.8,43.2C24.4,456.9,38.3,465,54,465h403.6c15.7,0,29.6-8.1,37.3-21.8C502.5,429.6,502.2,413.5,494.1,400.1zM473.9,431.5c-3.4,6-9.5,9.6-16.3,9.6H54c-6.9,0-13-3.6-16.4-9.6c-3.4-6-3.2-13.1,0.4-19L240.5,81.3c3.5-5.7,9.3-9,16-9c0,0,0,0,0,0c6.7,0,12.5,3.3,16,9l0,0l201,331.2C477.2,418.4,477.3,425.5,473.9,431.5z" />
            </g>
        </Icon>
    );
}
